import { useEffect, useState } from 'react';
import { FOOTER } from '@/constants/testIds';

const Footer = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <footer 
      data-testid={FOOTER.container}
      className="w-full py-6 border-t border-white/10 bg-[#050505] mt-auto"
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between text-sm">
        <div data-testid={FOOTER.copyright} className="text-[#71717A] font-body">
          © DSA With Kapil
        </div>
        <div data-testid={FOOTER.subtitle} className="text-[#FFB800] font-heading font-medium">
          Visual Learning Lab
        </div>
        <div className="text-[#71717A] font-code">
          {formatDate(currentTime)} • {formatTime(currentTime)}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
